import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import agent from "../api/agent";
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { BatchUploadTable } from "../models/batchUpload/batchUploadTable";
import { BatchUploadContact } from "../models/batchUpload/batchUploadContact";
import { BatchUpload } from "../models/pcs/batchUpload";

interface batchUploadDataState {
    batchUploadContacts: BatchUploadContact[] | null;
    batchUpload: BatchUpload | null;

    batchUploadStatus: ApiRequestStatus;
    getBatchUploadContactsStatus: ApiRequestStatus;
    getBatchUploadStatus: ApiRequestStatus;
}

const initialState: batchUploadDataState = {
    batchUploadContacts: null,
    batchUpload: null,

    batchUploadStatus: ApiRequestStatus.Idle,
    getBatchUploadContactsStatus: ApiRequestStatus.Idle,
    getBatchUploadStatus: ApiRequestStatus.Idle
}

export const getBatchUploadContactsAsync = createAsyncThunk<BatchUploadContact[], string>(
    'batchUploadSlice/getBatchUploadContactsAsync',
    async (batchUploadId, thunkAPI) => {
        try {
            return agent.batchUpload.getBatchUploadContactsAsync(batchUploadId);
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const batchUploadAsync = createAsyncThunk<string, BatchUploadTable>(
    'batchUploadSlice/batchUploadAsync',
    async (batchUploadTable, thunkAPI) => {
        try {
            return agent.batchUpload.uploadBatchAsync(batchUploadTable);
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const getBatchRecordAsync = createAsyncThunk<BatchUpload, string>(
    'batchUploadSlice/getBatchRecordAsync',
    async (batchId, thunkAPI) => {
        try {
            return agent.batchUpload.getBatchRecordAsync(batchId);
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const batchUploadSlice = createSlice({
    name: 'batchUploadSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getBatchUploadContactsAsync.pending, (state) => {
            state.getBatchUploadContactsStatus = ApiRequestStatus.Pending;
        });

        builder.addCase(getBatchUploadContactsAsync.fulfilled, (state, action) => {
            state.batchUploadContacts = action.payload;
            state.getBatchUploadContactsStatus = ApiRequestStatus.Fulfilled;
        });

        builder.addCase(getBatchUploadContactsAsync.rejected, (state) => {
            state.getBatchUploadContactsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(batchUploadAsync.pending, (state) => {
            state.batchUploadStatus = ApiRequestStatus.Pending;
        });

        builder.addCase(batchUploadAsync.fulfilled, (state, action) => {
            state.batchUploadStatus = ApiRequestStatus.Fulfilled;
        });

        builder.addCase(batchUploadAsync.rejected, (state) => {
            state.batchUploadStatus = ApiRequestStatus.Rejected;
        });


        builder.addCase(getBatchRecordAsync.pending, (state) => {
            state.getBatchUploadStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getBatchRecordAsync.fulfilled, (state, action) => {
            state.batchUpload = action.payload;
            state.getBatchUploadStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(getBatchRecordAsync.rejected, (state) => {
            state.getBatchUploadStatus = ApiRequestStatus.Rejected;
        });
    })
})
